define('modules/campaigns/campaigns_filter_view',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',

  'modules/list/list_view',
  'modules/loading/loading_spinner_view',

  'text!./campaigns_filter_template.html',

  './campaigns_filter_model',

  'session',
], function (
  Backbone,
  $,
  _,
  URI,
  ListView,
  Loading,
  WeeklyOffersFilterTemplate,
  WeeklyOfferFilterModel,
  session
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];
      this.render();

      this.setupFilters();
      this.filterModel = new WeeklyOfferFilterModel();

      this.listenTo(
        this.filterModel,
        'sync',
        function (model) {
          var i;

          if (this.zoneFilterControl) {
            var modelZoneOptions = model.get('zoneOptions');
            if (modelZoneOptions) {
              modelZoneOptions = modelZoneOptions.options;
            }

            for (i = 0; i < modelZoneOptions.length; i++) {
              this.zoneFilterControl[0].selectize.addOption(
                modelZoneOptions[i]
              );
            }
          }

          return {};
        },
        this
      );

      this.filterModel.fetch();
    },

    filterModel: null,
    hasSidebar: false,
    subViews: [],

    zoneFilterControl: null,
    searchTextControl: '',

    template: _.template(WeeklyOffersFilterTemplate),

    events: {
      'keyup input#search-field': 'onSearchTextChanged',
    },

    onSearchTextChanged: _.debounce(function () {
      this.triggerFilterOptionChange();
    }, 500),

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    setupFilters: function () {
      var that = this;

      this.zoneFilterControl = this.$('#active_zones').selectize({
        plugins: ['remove_button'],
        create: false,
        // sortField: 'text',
        onChange: function (value) {
          that.triggerFilterOptionChange();
        },
      });

      return this;
    },

    triggerFilterOptionChange: function () {
      var zoneOptions = this.filterModel.get('zoneOptions');
      zoneOptions.active = this.zoneFilterControl[0].selectize.items;
      this.filterModel.set('zoneOptions', zoneOptions);

      var searchText = $('input#search-field')[0].value;
      this.filterModel.set('searchText', searchText);

      this.filterModel.trigger('change', this.filterModel);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

